export default __webpack_public_path__ + "static/media/convocatoria3.4877b013.jpg";